import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicForm } from '../../services/api/formApi';
import EmailCollectionModal from './EmailCollectionModal';
import FormResponse from './FormResponse';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const PublicForm = () => {
  const { formId } = useParams();
  const [form, setForm] = useState(null);
  useDocumentTitle(form?.title || 'Fill Form');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const loadForm = async () => {
      try {
        setLoading(true);
        const formData = await getPublicForm(formId);
        setForm(formData);

        // Check if email collection is required
        if (formData.settings.collectEmail) {
          const storedEmail = localStorage.getItem(`form_${formId}_email`);
          if (storedEmail) {
            setUserEmail(storedEmail);
          } else {
            setShowEmailModal(true);
          }
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadForm();
  }, [formId]);

  const handleEmailSubmit = (email) => {
    setUserEmail(email);
    localStorage.setItem(`form_${formId}_email`, email);
    setShowEmailModal(false);
  };

  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted">Loading form...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center">
          <h2 className="text-danger mb-3">Form Not Available</h2>
          <p className="text-muted mb-4">{error}</p>
          <button onClick={() => window.history.back()} className="btn btn-primary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!form) {
    return null;
  }

  // Check if form is published
  if (form.status !== 'PUBLISHED') {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center">
          <h2 className="text-danger mb-3">This form is closed</h2>
          <p className="text-muted mb-4">This form is not currently accepting responses.</p>
          <button onClick={() => window.history.back()} className="btn btn-primary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const handleSwitchAccount = () => {
    localStorage.removeItem(`form_${formId}_email`);
    setUserEmail(null);
    setShowEmailModal(true);
  };

  return (
    <div className="min-vh-100 bg-light">
      <EmailCollectionModal
        isOpen={showEmailModal}
        onSubmit={handleEmailSubmit}
        onClose={() => setShowEmailModal(false)}
        mandatory={form?.settings?.collectEmail}
        formId={formId}
      />
      <FormResponse
        form={form}
        userEmail={userEmail}
        onSwitchAccount={handleSwitchAccount}
      />
    </div>
  );
};

export default PublicForm;
